<script setup>
import { computed } from 'vue';

import SelectMenu from 'dashboard/components-next/selectmenu/SelectMenu.vue';

import KraftchatAIRulesSwitchItem from './KraftchatAIRulesSwitchItem.vue';

import {
  autonomyOptions,
  rulesContent,
} from '../../helpers/kraftchatAIRulesConfig';

const props = defineProps({
  policy: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:policy']);

const selectedAutonomyLabel = computed(() => {
  return (
    autonomyOptions.find(option => option.value === props.policy.autonomy_level)
      ?.label || rulesContent.autonomyLabel
  );
});

const selectedAutonomyDescription = computed(() => {
  return autonomyOptions.find(
    option => option.value === props.policy.autonomy_level
  )?.description;
});

const updateField = (key, value) => {
  emit('update:policy', {
    ...props.policy,
    [key]: value,
  });
};
</script>

<template>
  <div class="grid gap-4 md:grid-cols-2">
    <div class="flex flex-col gap-1">
      <label class="mb-0.5 text-heading-3 text-n-slate-12">
        {{ rulesContent.autonomyLabel }}
      </label>

      <SelectMenu
        :model-value="policy.autonomy_level"
        class="!w-full [&>button]:!h-10 [&>button]:!w-full [&>button]:!max-w-none [&>button]:!justify-between [&>button]:!px-3 [&>div]:!w-full [&>div]:!max-w-none"
        :label="selectedAutonomyLabel"
        :options="autonomyOptions"
        sub-menu-position="bottom"
        @update:model-value="updateField('autonomy_level', $event)"
      />

      <p
        v-if="selectedAutonomyDescription"
        class="mt-1 text-sm leading-6 text-n-slate-11"
      >
        {{ selectedAutonomyDescription }}
      </p>
    </div>

    <KraftchatAIRulesSwitchItem
      :label="rulesContent.autoReplyLabel"
      :description="rulesContent.autoReplyDescription"
      :model-value="policy.auto_reply_enabled"
      @update:model-value="updateField('auto_reply_enabled', $event)"
    />
  </div>
</template>
